import { reduxForm, reset } from 'redux-form'
import moment from 'moment'

import CommentForm from '../../components/comments/comment-form'

import { createCommentForWorkOrder } from '../../actions/comments'

const fields = [
  'body',
  'timezone'
]

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      dispatch(createCommentForWorkOrder(ownProps.workOrderId, data))
        .then(() => dispatch(reset('createWorkOrderComment')))
    }
  }
}

export default reduxForm(
  {
    fields,
    initialValues: {
      timezone: moment.tz.guess()
    },
    form: 'createWorkOrderComment'
  },
  undefined,
  mapDispatchToProps
)(CommentForm)



// WEBPACK FOOTER //
// ./src/containers/comments/create-work-order-comment-container.js